import {EmptyResult} from '@wallaby-ui/core';
import * as React from 'react';

import styles from './ReportsList.less';
import {ReportsListItem} from './ReportsListItem';
import {ReportsConfig} from 'src/js/model/reports_config';

interface OwnProps {
  caseType: string;
  reportsConfig: ReportsConfig;
  reportId: string;
  data: Record<string, any>;
}

type Props = OwnProps;

export const ReportsList: React.FC<Props> = (props) => {
  const {caseType, reportsConfig, reportId, data} = props;

  return (
    <div className={styles.dlReportsList}>
      {reportsConfig &&
      reportsConfig.isLoaded() &&
      // TODO-JK: remove and refactor usage of getByView
      reportsConfig.getReportsByView(caseType).length > 0 ? (
        reportsConfig
          .getReportsByView(caseType)
          .map((reportConfig) => (
            <ReportsListItem
              key={reportConfig.getId()}
              reportConfig={reportConfig}
              reportId={reportId}
              data={data}
            />
          ))
      ) : (
        <EmptyResult />
      )}
    </div>
  );
};

ReportsList.displayName = 'ReportsList';
